import React, { useMemo } from 'react';
import Wizard from 'Views/Components/Wizard/Wizard';
import { INSTITUTION_IMAGES } from 'Constants';
import { Button, QuickTypes } from 'Views/Components/Button/Button';
import { SAVE_STATUS } from 'Views/Components/AutoSaveHeader/AutoSaveHeader';
import cn from 'classnames';
import { IStudyPlanWizardData } from 'Views/Pages/Frontend/StudyPlanWizard/StudyPlanWizard';
import { useWizardContext } from 'Views/Components/Wizard/WizardContext';
import { useHistory } from 'react-router-dom';

const StudyPlanWizardHeader = () => {
	const history = useHistory();

	const {
		autoSaveStatus,
		data,
		setAndSaveData,
	} = useWizardContext<IStudyPlanWizardData>();

	const isSaving = useMemo(
		() => autoSaveStatus === SAVE_STATUS.SAVING,
		[autoSaveStatus],
	);

	const isSaved = useMemo(
		() => autoSaveStatus === SAVE_STATUS.SAVED,
		[autoSaveStatus],
	);

	const saveStatusLabel = (
		<div className="success-label">
			<span className={`icon icon-only ${isSaved ? 'icon-check-circle' : ''}`} />
			<span
				className={cn(
					'status',
					{
						saving: isSaving,
						saved: isSaved,
					},
				)}
			/>
		</div>
	);

	const saveAndExit = async () => {
		if (!data) {
			console.error('Error: attempted to save undefined data');
			return;
		}
		await setAndSaveData({ ...data });
		history.goBack();
	};

	return (
		<Wizard.Header>
			<div className="left">
				<div className="institute-logo">
					<img
						src={INSTITUTION_IMAGES.LOGO}
						className="institute-logo"
						alt="institute-logo"
					/>
				</div>
				<div className="title">
					{data?.studyPlan?.name}
				</div>
			</div>
			<div className="right">
				{saveStatusLabel}
				<Button
					onClick={saveAndExit}
					disabled={data?.fetchPlanRequestState !== 'done' || autoSaveStatus === SAVE_STATUS.SAVING}
					quickTypes={QuickTypes.Secondary}
				>
					Save & Exit
				</Button>
			</div>
		</Wizard.Header>
	);
};

export default StudyPlanWizardHeader;
